import React from 'react';
import { TEXT_COLOR } from '../../theme';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function InfoField({ label, value }) {
    return (
        <Box>
            <Typography sx={{
                display: 'block',
                fontSize: '13px',
                fontWeight: 500,
                letterSpacing: '0.92px',
                textTransform: 'uppercase',
                color: TEXT_COLOR,
                whiteSpace: 'nowrap',
                mb: 0.75,
            }}>
                {label}
            </Typography>
            <Typography sx={{
                fontSize: '17px',
                fontWeight: 600,
                letterSpacing: '-0.285px',
                lineHeight: '28px',
                color: 'text.primary',
            }}>
                {value}
            </Typography>
        </Box>
    );
}

export default function ReportInfoGrid({
    nombre, edad, posicion, fecha_test,
    currentCapacity, match_persona_rol, potentialCapacity, futurePotential,
    tr,
}) {
    return (
        <Box sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            columnGap: 3,
            rowGap: 1.5,
        }}>
            <InfoField label={tr('name')} value={nombre} />
            <InfoField label={tr('age')} value={edad} />
            <InfoField label={tr('role')} value={posicion} />
            <InfoField label={tr('date')} value={fecha_test} />
            <InfoField label={tr('cur_cap')} value={currentCapacity} />
            <InfoField label={tr('match_person_role')} value={match_persona_rol} />
            <InfoField label={tr('potential_cap')} value={potentialCapacity} />
            <InfoField label={tr('potential_future')} value={futurePotential} />
        </Box>
    );
}
